import React from "react";
import { useAuth } from "../../core/contexts/AuthContext";
import { DataProvider } from "../../core/contexts/DataContext";
import MeetingsTabs from "./Meetings";


function TopBar() {
  const { user, logout } = useAuth();

  const onLogout = async () => {
    logout();
  };

  return (
    <header style={styles.topBar}>
      <div style={styles.left}>
      </div>

      <div style={styles.right}>
        {user?.name ? (
          <span style={styles.user}>{user.name}</span>
        ) : null}

        <button style={styles.logoutBtn} onClick={onLogout}>
          Logout
        </button>
      </div>
    </header>
  );
}

export function MeetingsRoute() {
  const { isSilenceLogin } = useAuth();
  return (
    <div style={styles.page}>
      {!isSilenceLogin && <TopBar />}

      <main style={styles.body}>
        <DataProvider>
          <MeetingsTabs />
        </DataProvider>
      </main>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  topBar: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 14px",
    borderBottom: "1px solid #e5e5e5",
    background: "#fff",
  },
  left: { display: "flex", alignItems: "center", gap: 8 },
  right: { display: "flex", alignItems: "center", gap: 10 },
  user: { opacity: 0.8, fontSize: 13 },
  logoutBtn: {
    padding: "6px 10px",
    borderRadius: 8,
    border: "1px solid #ddd",
    background: "#fff",
    cursor: "pointer",
  },
  body: { flex: 1, overflow: "auto" },
};